<template>
    <div class="background">
        <div style="background-color: #FFFFFF; width: 100%; height: 90%; margin: 10px 0 10px 10px">
            <el-row style="height: 10%; margin-bottom: 10px">
                <el-col :span="13">
                    <div class="haeders" style="margin: 13px 0 0 20px">预约信息管理</div>
                </el-col>
                <el-col :span="3" class="style1" style="margin-top: 20px">
    <el-date-picker
        :clearable=false
      v-model="value1"
      type="date"
      placeholder="选择日期"
      @change="handleDateChange">
    >
    </el-date-picker>
<!--                    <el-input-->
<!--                        placeholder="订单号"-->
<!--                        prefix-icon="el-icon-search"-->
<!--                        v-model="searchId"-->
<!--                        size="small"-->
<!--                        @keydown.enter="search" @blur="search" @clear="refresh" clearable-->
<!--                    >-->
<!--                    </el-input>-->
                </el-col>
<!--                <el-col span="1" class="style2">-->
<!--                    <i style="size: 12px">搜索</i>-->
<!--                </el-col>-->
<!--                <el-col span="2">-->
<!--                    <div class="style2">-->
<!--                        <i class="el-icon-date">日期</i>-->
<!--                    </div>-->

<!--                </el-col>-->
            </el-row>
            <el-row>
<!--              <div>-->
<!--                <el-col :span="2">-->
<!--                    <div style="font-size: 18px; margin-left: 20px">预约列表</div>-->
<!--                </el-col>-->
<!--              </div>-->

                <el-col :span="12" style="font-size: 15px; margin-top: 5px; margin-left: 13px">
                    预约状态
                    <el-radio v-model="radio" label="1" class="custom-radio">全部</el-radio>
<!--                    <el-radio v-model="radio" label="2" class="custom-radio">已预约</el-radio>-->
<!--                    <el-radio v-model="radio" label="3" class="custom-radio">已取消</el-radio>-->
<!--                    <el-radio v-model="radio" label="4" class="custom-radio">以核销</el-radio>-->
                </el-col>
<!--                <el-col :span="8" style="font-size: 15px; margin-top: 5px">-->
<!--                    渠道-->
<!--                    <el-radio v-model="radio1" label="1">小程序</el-radio>-->
<!--                    <el-radio v-model="radio1" label="2">其他渠道</el-radio>-->
<!--                </el-col>-->

            </el-row>
            <div class="table_container">
                <el-table
                    border
                    :data="tableData"
                    style="width: 100%"
                    height="500"
                >
                    <el-table-column
                        type="index"
                        label="序号"
                        width="100"
                        >
                    </el-table-column>
                    <el-table-column
                        label="预约时间"
                        prop="date"
                    >
                    </el-table-column>
                    <el-table-column
                        label="场次"
                        prop="booking_time">
                    </el-table-column>
                    <el-table-column
                        label="人数"
                        prop="reservationNum"
                    >
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '../components/headTop'
import $ from 'jquery'

export default {
    data() {
        return {
            tableData: [],
            currentRow: null,
            offset: 0,
            limit: 20,
            count: 0,
            pagination: {
                page: 1,
                size: 20,
                total_pages: 1,
                total: 1,
                pageSizeOption: [20, 50, 100, 200]
            },
            radio:'1',
            radio1:'',
            searchId:'',
          value1:new Date()
        }
    },
    components: {
        headTop,
    },
    created() {
        this.getReservationOrder(0)
    },
    methods: {

      handleDateChange(value){
        const year = value.getFullYear();
        // 获取月，需要注意月份是从0开始计数的，所以要加1
        const month = String(value.getMonth() + 1).padStart(2, '0');
        // 获取日
        const day = String(value.getDate()).padStart(2, '0');
        // 组合成指定格式的日期字符串
        var formattedDate = `${year}-${month}-${day}`;
        $.ajax({
          url: this.$settings.BASE_URL + "order/booking_list",
          type: 'POST',
          dataType: 'json',
          //new Date()
          // data: {'date': this.timeDate},
          data: {'date': formattedDate},
          xhrFields: {
            withCredentials: true
          },
          success: (res) => {
            var tableData = []
            if (res.info == 'ok' && res.result.length > 0) {
              res.result.forEach(function (reservation) {
                var reservationData = {}
                if (reservation["sum(ticket_num)"] == 0) {
                  reservationData["reservationNum"] = 0
                } else {
                  reservationData["reservationNum"] = reservation["sum(ticket_num)"]
                }
                if(reservation.order_id){
                  reservationData["order_id"] = reservation.order_id
                }else{
                  reservationData["order_id"] = '/'
                }
                reservationData["date"] = formattedDate
                reservationData["booking_time"] = reservation.booking_time

                // if (reservation.ticketChecked == "已核验") {
                //   reservationData["ticketCheckedNum"] = reservation["sum(ticket_num)"]
                // } else {
                //   reservationData["ticketCheckedNum"] = 0
                // }
                tableData.push(reservationData)

              })
              this.tableData = tableData
            }
          },
          error: (error) => {
            console.log('请求失败：', error)
          }
        })
      },
      getReservationOrder() {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        // 获取月，需要注意月份是从0开始计数的，所以要加1
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        // 获取日
        const day = String(currentDate.getDate()).padStart(2, '0');
        // 组合成指定格式的日期字符串
        var formattedDate = `${year}-${month}-${day}`;
        this.timeDate = formattedDate
        $.ajax({
          url: this.$settings.BASE_URL + "order/booking_list",
          type: 'POST',
          dataType: 'json',
          //new Date()
          // data: {'date': this.timeDate},
          data: {'date': formattedDate},
          xhrFields: {
            withCredentials: true
          },
          success: (res) => {
            var tableData = []
            if (res.info == 'ok' && res.result.length > 0) {
              res.result.forEach(function (reservation) {
                var reservationData = {}
                if (reservation["sum(ticket_num)"] == 0) {
                  reservationData["reservationNum"] = 0
                } else {
                  reservationData["reservationNum"] = reservation["sum(ticket_num)"]
                }
                if(reservation.order_id){
                  reservationData["order_id"] = reservation.order_id
                }else{
                  reservationData["order_id"] = '/'
                }
                reservationData["date"] = formattedDate
                reservationData["booking_time"] = reservation.booking_time

                // if (reservation.ticketChecked == "已核验") {
                //   reservationData["ticketCheckedNum"] = reservation["sum(ticket_num)"]
                // } else {
                //   reservationData["ticketCheckedNum"] = 0
                // }
                tableData.push(reservationData)

              })
              this.tableData = tableData
            }
          },
          error: (error) => {
            console.log('请求失败：', error)
          }
        })
      },
    }
}
</script>

<style lang="less">
@import '../style/mixin';

.table_container {
    padding: 20px;
   width: 80%;  /* 或者你可以设置固定宽度 */
  margin: 0 auto;  /* 水平居中 */
}

.background {
    background-color: #F4F5FA;
}

.haeders {
    width: 132px;
    height: 31px;
    font-family: PingFang SC sans-serif;
    font-size: 20px;
    font-weight: 600;
    line-height: 30.8px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #2D334A;
}

.style1 {
    width: Hug (68px)px;
    height: Fixed (29px)px;
    border-radius: 4px 4px 4px 4px;
    text-align: center;
    justify-items: center;
    justify-content: center;
    margin: 20px 10px 0 20px;
}

.style2 {
    width: Hug (44px)px;
    height: Fixed (29px)px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #5C16F2;
    text-align: center;
    justify-items: center;
    justify-content: center;
    color: #5C16F2;
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 16.94px;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin: 10px 30px 0 0;
    padding: 6px;

}
.el-icon-date{
border-radius:0 !important;
  color:#FFFFFF !important;
  border:0 !important;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width: 150px !important;
}
//.el-icon-edit {
//    color: #5C16F2;
//}
//
//.el-icon-view {
//    color: #5C16F2;
//}
//.custom-radio.el-radio__input.is-checked +.el-radio__label {
//   color: #5C16F2; /* 将文字设置为紫色 */
//}
//.custom-radio.el-radio__input.is-checked.el-radio__inner {
//  border-color: #5C16F2; /* 将单选框边框设置为紫色 */
//  background-color: #5C16F2; /* 将单选框内部填充颜色设置为紫色 */
//}
</style>
